import { render, staticRenderFns } from "./history.vue?vue&type=template&id=78f19d87&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style1 from "./history.vue?vue&type=style&index=1&id=78f19d87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f19d87",
  null
  
)

export default component.exports